import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithReauth } from "../api.config";

export const calendarEventsApi = createApi({
  reducerPath: "calendarEventsApi",
  baseQuery: baseQueryWithReauth,
  tagTypes: ["CalendarEvents"],
  endpoints: (builder) => ({
    getCalendarEvents: builder.query({
      query: ({ timeMin, timeMax, limit } = {}) => ({
        url: "/calendar-events",
        method: "GET",
        params: { timeMin, timeMax, limit },
      }),
      providesTags: ["CalendarEvents"],
      transformResponse: (response) => response.data || [],
    }),
    createCalendarEvent: builder.mutation({
      query: (eventData) => ({
        url: "/calendar-events",
        method: "POST",
        body: eventData,
      }),
      invalidatesTags: ["CalendarEvents"],
    }),
    updateCalendarEvent: builder.mutation({
      query: ({ id, ...eventData }) => ({
        url: `/calendar-events/${id}`,
        method: "PUT",
        body: eventData,
      }),
      invalidatesTags: ["CalendarEvents"],
    }),
    deleteCalendarEvent: builder.mutation({
      query: ({ id }) => ({
        url: `/calendar-events/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["CalendarEvents"],
    }),
  }),
});

export const {
  useGetCalendarEventsQuery,
  useCreateCalendarEventMutation,
  useUpdateCalendarEventMutation,
  useDeleteCalendarEventMutation,
} = calendarEventsApi;
